import React from 'react';
import { Typography, Box } from '@mui/material';

const Diarios = () => {
  return (
    <Box>
      <Typography variant="h5">Diários</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Esta página está em desenvolvimento.
      </Typography>
    </Box>
  );
};

export default Diarios;
